var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{class:{ stuck: _vm.stuck },attrs:{"id":"site-header","role":"navigation"}},[_c('top-bar'),_c('nav-bar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }